export const DEFAULT_IP_SEARCHING_AGENT_NAME = 'eureka_ip_searching_agent';

const IP_SEARCHING_AGENT_NAME_BY_ROUTE_MATCHERS: Array<[RegExp, string]> = [
    [/\/novelty-check-report(?:\/|$)/, 'ip_searching_novelty_search'],
    [/\/(?:fto-report|fto-pro)(?:\/|$)/, 'ip_searching_fto'],
    [/\/(?:design-fto|image-fto-search)(?:\/|$)/, 'ip_searching_design_fto'],
];

/**
 * 根据当前 URL 或路由路径获取 IP Searching agent 名称
 */
export function getAgentNameByRoute(routeOrUrl?: string) {
    const routePath = getComparableRoutePath(routeOrUrl ?? getCurrentHref());
    const match = IP_SEARCHING_AGENT_NAME_BY_ROUTE_MATCHERS.find(([pattern]) => pattern.test(routePath));

    return match?.[1] ?? DEFAULT_IP_SEARCHING_AGENT_NAME;
}

function getComparableRoutePath(routeOrUrl: string) {
    const url = createUrl(routeOrUrl);
    const path = url.hash.startsWith('#/')
        ? url.hash.slice(1)
        : url.pathname;

    return path.split('?')[0].toLowerCase();
}

function createUrl(routeOrUrl: string) {
    try {
        return new URL(routeOrUrl, window.location.origin);
    } catch {
        return new URL(`https://example.com${routeOrUrl.startsWith('/') ? '' : '/'}${routeOrUrl}`);
    }
}

function getCurrentHref() {
    return window.location.href;
}
